module.exports = __webpack_public_path__ + "static/img/Inspiron_14_7460.c3a8abde.png";